module.exports = __webpack_public_path__ + "static/media/oneshelf-pic2.eac9ca74.JPG";